import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAdd, faChevronRight } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import { faCamera } from '@soundxyz/font-awesome/pro-solid-svg-icons/index.mjs';
import { IconButton } from '@components/main-components/icon-buttons/IconButton';
import { AccessibleLink } from '@components/main-components/link/AccessibleLink';
import type { Pathname } from '@components/main-components/link/AccessibleLink';

export interface LandingHeadingProps {
  header: string;
  pathnameUri: Pathname | null;
  onHeaderClick?: () => void;
  onDownloadScreenshotClicked?: () => void;
  onCreateClicked?: () => void;
}

export const LandingHeading = ({
  header,
  pathnameUri,
  onHeaderClick,
  onDownloadScreenshotClicked,
  onCreateClicked,
}: LandingHeadingProps) => {
  return (
    <div className="mb-2 flex w-full items-center justify-between sm:mb-4">
      <h1 className="font-title text-title-m font-medium lg:text-title-l">{header}</h1>
      {onDownloadScreenshotClicked && (
        <IconButton
          className="mb-0.5 ml-3"
          variant="tertiary"
          icon={<FontAwesomeIcon icon={faCamera} size="lg" />}
          onClick={onDownloadScreenshotClicked}
        />
      )}
      {onCreateClicked && (
        <IconButton
          className="mb-0.5 ml-1"
          variant="tertiary"
          icon={<FontAwesomeIcon icon={faAdd} size="lg" />}
          onClick={onCreateClicked}
        />
      )}
      <div className="flex-1" />
      {pathnameUri && (
        <div className="flex items-center">
          <AccessibleLink pathnameUri={pathnameUri} onClick={onHeaderClick}>
            <div className="hidden h-[28px] max-h-[28px] items-center rounded-md border border-solid border-base300 bg-white px-2 pb-1 pt-[5px] text-center hover:border-base100 hover:bg-base100 md:flex">
              <p className="font-title text-title-xxs font-medium text-base800">See All</p>
            </div>

            <div className="mb-[1px] ml-[8px] flex h-6 w-6 items-center justify-center md:hidden">
              <FontAwesomeIcon icon={faChevronRight} size="lg" className="text-black " />
            </div>
          </AccessibleLink>
        </div>
      )}
    </div>
  );
};
